module.exports = __webpack_public_path__ + "static/media/link.e48415e5.svg";